<template>
  <div class="dialogue-tool">
    <Poptip v-model="visible" :width="350" word-wrap placement="top-start" @on-popper-show="getDialogue">
        <Icon type="ios-text-outline" />
        <div class="api" slot="content">
            <List size="small">
              <Scroll >
                <ListItem v-for="(item, index) in dialogueList" :key="index">
                  <span @click="emitDialogue(item.value)" class="text-clamped">{{item.value}}</span>
                
                </ListItem>
              </Scroll>
              <div class="api" slot="header">
                <Input @on-change="searchDialogue()" v-model="keyword" placeholder="搜索" style="width: 300px" />
              </div>
            </List>
        </div>
    </Poptip>
  </div>
</template>
<script>
import conf from "../../conf";
import LazadaUtils from "../../../../utils/LazadaUtils";


export default {
  name: "faces",
  components: {},
  data() {
    return {
      dialogueList: [],
      keyword: '',
      tempList: [],
      visible: false
    };
  },
  methods: {
    getDialogue () {
      let self = this;
      let param = new FormData();
      param.set("store_id", this.$store.state.lazada.currentStore.id);
      param.set("sign_data", '');

      LazadaUtils.request(conf.getDialogue(), param).then(json => {
        console.log(json);
        self.dialogueList = json.result;
        self.tempList = json.result;
      })
    },
    emitDialogue (value) {
      this.$emit('updatemessagecon', value);
      this.visible = false;
    },
    searchDialogue () {
      if (this.keyword) {
        let list = new Array();
        for (let i=0; i<this.dialogueList.length; i++) {
          let pattern = new RegExp(this.dialogueList[i]['value'], "g");
          if ( pattern.test(this.keyword) ) {
            list.push(this.dialogueList[i]);
          }
        }
        console.log(list);
        this.dialogueList = list;
      } else {
        this.dialogueList = this.tempList;
      }
    }
  }
};
</script>

<style scoped lang="scss">

.dialogue-tool {
  display: inline-block;

  .ivu-poptip-popper {
    width: 300px!important;
    max-width: 300px!important;
    word-wrap: break-word;
  }
}
.ivu-poptip-popper {
  width: 300px!important;
  max-width: 300px!important;
  word-wrap: break-word;
}
.text-clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 16px;
  max-height: 48px;
  overflow-y: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  text-align: left;
  font-family: HelveticaNeue;
  font-size: 13px;
  letter-spacing: 0;
  cursor: pointer;text-align: left;
  font-family: HelveticaNeue;
  font-size: 13px;
  letter-spacing: 0;
  cursor: pointer;
}
</style>
